/* global ADV */
export const chartSettings = {
  chart: {
    type: 'column',
  },
  title: {
    text: '',
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  xAxis: {
    gridLineWidth: 0,
  },
  yAxis: {
    title: {
      text: '',
    },
    gridLineColor: '#ddd',
    gridLineDashStyle: 'Dot',
    gridLineWidth: 2,
    labels: {
      formatter() {
        return `$${ADV.util.short_number_format(this.value)}`;
      },
      style: {
        fontFamily: 'Open Sans, helvetica, sans-serif',
        fontSize: '13px',
        color: '#888',
      },
    },
  },
  series: [
    {
      name: 'Expenses',
      color: '#e5f8ff',
      fillOpacity: 1,
      borderColor: '#5abee4',
      borderWidth: 2,
    },
    {
      name: 'Expenses Covered',
      color: '#5abee4',
      fillOpacity: 1,

    },
  ],
  tooltip: {
    useHTML: true,
    shadow: false,
    borderWidth: 0,
    backgroundColor: 'rgba(255,255,255,0)',
    borderRadius: 0,
    formatter() {
      return `
        <div class="healthcare-chart-tooltip-container">
            <strong>${this.series.name}</strong>
            </br>
            ${this.x}/ $${ADV.util.number_format(this.y, 0)}
        </div>`;
    },
  },
  plotOptions: {
    column: {
      grouping: false,
      shadow: false,
      borderWidth: 0,
    },
  },
};

export const barChartSettings = {
  chart: {
    type: 'bar',
    spacingLeft: 20,
    spacingRight: 20,
    spacingBottom: 0,
  },
  title: {
    text: '',
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  yAxis: {
    title: {
      text: '',
      margin: 20,
      lineWidth: 0,
    },
    labels: {
      formatter() {
        return ADV.util.short_number_format(this.value);
      },
      style: {
        fontFamily: 'Open Sans, helvetica, sans-serif',
        fontSize: '13px',
        color: '#888',
      },
    },
    gridLineColor: '#ddd',
    gridLineDashStyle: 'Dot',
    gridLineWidth: 2,
    maxPadding: 0,
    tickAmount: 8,
  },
  xAxis: {
    title: {
      text: '',
    },
    labels: {
      enabled: false,
    },
    lineWidth: 0,
    maxPadding: 0,
  },
  series: [
    {
      name: 'Recommended Reserve',
      data: [],
      color: '#e5f8ff',
      fillOpacity: 1,
      borderColor: '#5abee4',
      borderWidth: 2,
    }, {
      name: 'Current Reserve',
      color: '#5abee4',
      fillOpacity: 1,
      data: [],
      borderColor: '#5abee4',
      borderWidth: 2,
    },
  ],
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      grouping: false,
      shadow: false,
      borderWidth: 0,
      states: {
        hover: {
          enabled: false,
        },
      },
    },
    series: {
      pointWidth: 90,
    },
  },
};
